<template>
    <div>
        <slot :school-id="schoolId"></slot>
    </div>
</template>

<script>
    export default {
        name: 'BaseWidget',
        data() {
            return {
                schoolId: this.$route.query.schoolId
            }
        }
    }
</script>

<style>
    body {
        min-height: initial !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/main/widgets/BaseWidget.vue